import { sortOptionsISelect } from "../helpers/sortISelect";
import { Language } from "../model/enumerations/language.model";
import { ISelect } from "../model/iSelect";

export const languageEnum = (): Array<ISelect> => {
  const language: Array<ISelect> = [
    {
      label: "Español",
      value: Language.SPANISH,
    },
    {
      label: "Chino",
      value: Language.CHINESE,
    },
    {
      label: "Holandés",
      value: Language.DUTCH,
    },
    {
      label: "Inglés",
      value: Language.ENGLISH,
    },
    {
      label: "Francés",
      value: Language.FRENCH,
    },
    {
      label: "Alemán",
      value: Language.GERMAN,
    },
    {
      label: "Italiano",
      value: Language.ITALIAN,
    },
    {
      label: "Japonés",
      value: Language.JAPANESE,
    },
    {
      label: "Coreano",
      value: Language.KOREAN,
    },
    {
      label: "Portugués",
      value: Language.PORTUGUESE,
    },
  ];
  return sortOptionsISelect(language);
};
